export default __webpack_public_path__ + "static/media/cat_dancer.84af5c80.png";